// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .venmo-button {
    background-color: ${(props) =>
      props.isVenmoBlueButton ? props.theme.colors.VENMO : props.theme.colors.WHITE};
    width: 100%;
    height: ${(props) => props.theme.spacing.LAYOUT_SPACING.MED};
    border-radius: ${(props) => props.theme.brandSpecificStyles.VENMO_PAYMENT_BUTTON_BORDER_RADIUS};
    border: 1px solid ${(props) => props.theme.colorPalette.venmoBorder};
    ${(props) =>
      props.isBagPage
        ? `display: flex;
    align-items: center;
    justify-content: center;`
        : ''}
  }

  .venmo-button-image {
    width: ${(props) => (props?.spc ? '88px' : props.theme.spacing.LAYOUT_SPACING.XL)};
    height: inherit;
    transform: ${(props) => props?.spc && 'scale(1.5)'};
    ${(props) =>
      props.isPaymentRedesignEnabled
        ? `
      height: 17px;
      transform: none;
    `
        : ''}
  }

  .venmo-continue-text {
    text-align: center;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    ${(props) =>
      props.isPaymentRedesignEnabled
        ? `
        font-size: 15px;
        font-weight: ${props.theme.fonts.fontWeight.extrabold};
        margin: 8px;
    `
        : ''}
  }
`;

export default styles;
